import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center">
      <div className="absolute inset-0">
        <img 
          src="https://static.readdy.ai/image/356e0a32a00e968a1405b9eb797d2bd9/b6b8391ed95a5a3872465ace6cf87836.jpeg"
          alt="Restaurant Interior"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/65"></div>
      </div>
      
      <div className="relative z-10 text-center text-white px-6 max-w-4xl w-full">
        <div className="mb-6">
          <p className="text-sm tracking-[0.4em] text-white/90 uppercase mb-6 drop-shadow-md">NORTHCOTE CENTRAL</p>
          <h1 className="text-5xl md:text-7xl font-light mb-4 tracking-wide drop-shadow-lg">Welcome to Yummy Lab</h1>
          <div className="w-20 h-0.5 bg-[#C0392B] mx-auto my-6"></div>
          <p className="text-xl md:text-2xl font-light tracking-wide text-white drop-shadow-md">AUTHENTIC CHINESE FOOD</p>
        </div>
        <div className="mt-10 flex items-center justify-center gap-4">
          <Link to="/reservation" className="px-10 py-4 bg-[#C0392B] text-white text-sm tracking-wider hover:bg-[#A93226] transition-all duration-300 whitespace-nowrap cursor-pointer rounded-sm">
            Booking
          </Link>
          <Link to="/menu" className="px-10 py-4 border border-white/70 text-white text-sm tracking-wider hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer rounded-sm">
            Menu
          </Link>
        </div>
      </div>
    </section>
  );
}
